import { AsyncPipe } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { MegaMenuItem } from 'primeng/api';
import { MegaMenu } from 'primeng/megamenu';
import { map, of } from 'rxjs';
import { AuthService, NavbarService } from '#services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-navbar',
  imports: [MegaMenu, AsyncPipe],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  // menuItems$ = of<MenuItem[]>([]);
  menuItems$ = of<MegaMenuItem[]>([]);

  private _navBarService = inject(NavbarService);
  private _authService = inject(AuthService);

  hasAccess: Signal<boolean>;

  constructor() {
    this.menuItems$ = this._navBarService.getNavigation();
    // of<MegaMenuItem[]>();

    this.hasAccess = toSignal(this._authService.userDetails$.pipe(map(user => !!user?.hasAccess)), {
      initialValue: false,
    });
  }
}
